import { GatewayKind, GatewayStatus } from "src/components/shared-components/enum/enumGateway";
import { EnumStringConverter } from "../../../components/shared-components/enum/enum-string-converter";
import { Gateway } from "../../../components/shared-components/class/general-classes/gateway";

export class GatewayKindGroup {
  public kind: GatewayKind = GatewayKind.UNKNOWN;
  public listGateways: Array<Gateway> = new Array<Gateway>();
  public status: GatewayStatus = GatewayStatus.UNKNOW;
  public active: boolean = true;
  // GF: used at first to show the name only on hover of the mouse
  public visibleName: string = "";

  public constructor(kind: GatewayKind) {
    this.kind = kind;
  }

  public isVisible(): boolean {
    return (
      this.kind !== GatewayKind.VIRTUAL_VARIABLE &&
      this.kind !== GatewayKind.MQTT
    );
  }

  public gatewayKindGroupStatus(): GatewayStatus {
    this.status = GatewayStatus.CONNECTED;
    for (let i = 0; i < this.listGateways.length; i++) {
      if (
        this.listGateways[i].active &&
        this.listGateways[i].status < this.status
      ) {
        this.status = this.listGateways[i].status;
      }
    }
    return this.status;
  }

  public gatewayKindGroupActive(): boolean {
    this.active = false;
    for (let i = 0; i < this.listGateways.length; i++) {
      if (this.listGateways[i].active) {
        this.active = true;
        break;
      }
    }
    return this.active;
  }

  public addGateway(gateway: Gateway) {
    const indexGateway: number = this.listGateways.findIndex(
      (g: Gateway) => g.instanceGUID === gateway.instanceGUID
    );

    if (indexGateway < 0) {
      this.listGateways.push(gateway);
    } else {
      this.listGateways[indexGateway] = new Gateway(gateway);
      this.listGateways[indexGateway].color();
    }

    this.gatewayKindGroupStatus();
    this.failedBusOperationCount();
    this.gatewayKindGroupActive();
  }

  /**
   * Get gateay color
   *
   * @returns
   */
  public color(): string {
    let color: string = "error";

    if (this.kind !== GatewayKind.ACCESS_CONTROL) {
      if (this.active) {
        switch (this.status) {
          case GatewayStatus.CONNECTED:
            color = "success";
            break;
          case GatewayStatus.NOT_CONNECTED:
            color = "danger";
            break;
          case GatewayStatus.CONNECTING:
            color = "warning";
            break;
        }
      }
    } else {
      color = "success";
    }

    return color;
  }

  /**
   * Get gatewyay kind name
   *
   * @returns
   */
  public gatewayKindName(): string {
    return EnumStringConverter.gatewayKindToStringEnum(this.kind);
  }

  public failedBusOperationCount(): number {
    let result: number = 0;
    this.listGateways.forEach((gateway) => {
      result += gateway.failedBusOperationCount;
    });

    return result;
  }
}
